"use client";

import { useRouter } from "next/navigation";

import { buttonVariants } from "@/components/fun-ui/Button";
import { useCookie } from "@/hooks/useCookie";
import { cn } from "@/lib/utils";

export function LandingFinalCta() {
  const router = useRouter();
  const cookieHasNickname = !!useCookie("nickname");

  return (
    <button
      type="button"
      onClick={() => {
        router.push(cookieHasNickname ? "/papers" : "/login");
      }}
      className={cn(
        buttonVariants({ variant: "default" }),
        "py-0 rounded-full cursor-pointer",
        "h-[52px] text-lg w-[170px] absolute left-1/2 bottom-[210px] -translate-x-1/2 -translate-y-1/2",
      )}
    >
      {cookieHasNickname ? "进入 Findin" : "免费试用"}
    </button>
  );
}
